import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Button } from 'ypf-pas-general-ui-components';
import { BsChevronLeft } from 'react-icons/bs';
import './MainTitle.scss';

const MainTitle = ({ nombre, isSDS, previusPath }) => {
  const history = useHistory();

  const handleOnClickBackButton = () => {
    // nombre de variable no corresponde con su valor,
    // isSDS esta formado por un objeto, tanto SDS como MSDS contienen un objeto
    // entonces las 2 opciones pasan esta validacion
    if (isSDS) {
      history.push({ pathname: isSDS?.pathname, template: true });

      return;
    }
    if (previusPath === '/createMultiple')
      history.push({
        pathname: previusPath,
        openTemplateMOdal: true
      });
    else {
      history.push(previusPath || '/');
    }
  };

  return (
    <div className="container-main-title">
      <div className="title">
        <Button
          colorIcon="primary"
          icon={BsChevronLeft}
          onClick={handleOnClickBackButton}
          type="button"
          variant="white"
          widthButton="42px"
        />

        <h2 className="pas-title">{nombre}</h2>
      </div>
    </div>
  );
};

MainTitle.propTypes = {
  nombre: PropTypes.string,
  isSDS: PropTypes.shape({
    contractNumber: PropTypes.number,
    isSDS: PropTypes.bool,
    pathname: PropTypes.string
  }),
  previusPath: PropTypes.string
};

MainTitle.defaultProps = {
  nombre: '',
  previusPath: '',
  isSDS: null
};

export default MainTitle;
